import getRandomInt from './getRandomInt';

export default getRandomInt;
